<template>
  <b-row
    v-if="documentRequestData"
  >
    <b-col cols="6">
      <b-row>
        <b-col cols="12">
          <document-request-info-card :document-request-data="documentRequestData" />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card>
            <p>{{ documentRequestData.description }}</p>
          </b-card>
        </b-col>
      </b-row>

      <b-row
        v-if="
          documentRequestData.requestedDocuments &&
            documentRequestData.requestedDocuments.length > 0
        "
      >
        <b-col cols="12">
          <document-list
            :documents="documentRequestData.requestedDocuments"
            @update-document-requested="updateDocumentRequested"
            @update-user-requested="updateUserRequested"
          />
        </b-col>
      </b-row>

      <b-row
        v-if="
          documentRequestData.attachments &&
            documentRequestData.attachments.length > 0
        "
      >
        <b-col cols="12">
          <attachment-list
            :attachments="documentRequestData.attachments"
            @update-attachment-requested="updateAttachmentRequested"
          />
        </b-col>
      </b-row>
    </b-col>
    <b-col
      cols="6"
      style="height: 100%"
    >
      <b-row>
        <div style="width: 100%; margin-bottom: 20px">
          <b-col cols="12">
            <b-form-textarea
              ref="commentTextRef"
              v-model.trim="commentText"
              :placeholder="$t('write_comment')"
              rows="3"
              no-resize
            />
          </b-col>

          <b-col cols="12">
            <b-button
              variant="outline-primary"
              :disabled="!commentText"
              block
              style="margin-top: 7px"
              @click="handleAddCommentText"
            >
              {{ $t('documentRequests.btn.addComment') }}
            </b-button>
          </b-col>
        </div>
      </b-row>
      <comment-list
        :comments="documentRequestData.comments"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BFormTextarea, BButton, BCard,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import useDocumentRequestView from './useDocumentRequestView'
import DocumentRequestInfoCard from './DocumentRequestInfoCard.vue'
import DocumentList from './DocumentList.vue'
import AttachmentList from './AttachmentList.vue'
import CommentList from './CommentList.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormTextarea,
    BCard,
    BButton,
    DocumentRequestInfoCard,
    DocumentList,
    AttachmentList,
    CommentList,
  },
  data() {
    return {
      commentText: '',
      processer: {},
    }
  },
  beforeCreate() {
    this.$store.dispatch('appAuth/getCurrentUser')
      .then(res => {
        const user = JSON.parse(JSON.stringify(res))
        if (user.role === 'admin') {
          this.customerSendVerification = true
        }
        this.processer = {
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
        }
      })
  },
  methods: {
    handleAddCommentText() {
      this.addComment({
        text: this.commentText,
        date: new Date(),
        submitter: `${this.processer.firstName} ${this.processer.lastName}`,
      })
      this.commentText = ''
    },
  },
  setup() {
    const {
      documentRequestData,
      updateDocumentRequested,
      updateAttachmentRequested,
      updateUserRequested,
      addComment,
    } = useDocumentRequestView()

    return {
      documentRequestData,
      updateDocumentRequested,
      updateAttachmentRequested,
      updateUserRequested,
      addComment,
    }
  },
}
</script>

<style></style>
